import React from 'react';

import { SearchAutoImg } from 'assets/img';
import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';

import { DriverCard } from '../DriverCard/DriverCard';

import * as S from './List.styles';

export const List = ({ drivers = [] }) => {
  if (!drivers.length) {
    return (
      <S.EmptyContainer>
        <S.EmptyListImage src={SearchAutoImg} />
        <S.Title>Сейчас в списке нет водителей</S.Title>
        <S.SubTitle>Добавьте хотя бы одного водителя</S.SubTitle>
      </S.EmptyContainer>
    );
  }

  return drivers.reduce(
    (acc, { [DRIVER_FIELDS.ID]: id, [DRIVER_FIELDS.IS_DELETED]: isDeleted }) => {
      if (!isDeleted) {
        acc.push(<DriverCard id={id} key={`driver-${id}`} />);
      }

      return acc;
    },
    []
  );
};
